import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Label from '@atoms/label'

const propTypes = {}

const TagsComponent = ({
  tags = [],
  fill,
  className,
  prefix,
  suffix,
  solid,
  ...rest
}) => {
  return (
    <div className={className}>
      {prefix}
      {tags.map((tag, i) => {
        return (
          <Label
            {...rest}
            solid={solid}
            fill={fill ? 'true' : undefined}
            key={`${tag.name}-${i}`}
            suffix={tag.suffix}
            link={tag.link || undefined}
          >
            {tag.name}
          </Label>
        )
      })}
      {suffix}
    </div>
  )
}

TagsComponent.propTypes = {
  tags: PropTypes.array,
  fill: PropTypes.bool,
  prefix: PropTypes.node,
  suffix: PropTypes.string,
  solid: PropTypes.bool,
  className: PropTypes.string
}

const Tags = styled(TagsComponent)`
  display: flex;
  ${({ wrap }) => {
    if (wrap === 'left') {
      return `
        flex-wrap: wrap;
        margin: -4px;
        align-items: center;
      `
    } else {
      return `
        flex-wrap: wrap;
        margin: -4px;
        align-items: center;
        justify-content: center;
      `
    }
  }}

  ${({ fill }) => {
    if (fill) {
      return `
        width: ${fill};
        flex-direction: column;
      
      `
    }
  }}

  ${Label} {
    margin: 0.25rem 0.25rem;
  }
`

Tags.propTypes = propTypes
export default Tags
